<template>
  <div class="app">
    <Notification />
    <router-view name="SideBar" />
    <div class="app__container" :class="{ active: isSidebarShown }">
      <MobileMenu />
      <router-view />
    </div>
  </div>
</template>

<script>
import MobileMenu from '@/Vue/components/MobileMenu/MobileMenu.vue';
import Notification from './Vue/common/Notification/Notification.vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import api from '@/js/services/api';
import { watch, computed } from 'vue';
import WalletService from '@/js/services/wallet.service';

export default {
  components: { MobileMenu, Notification },

  setup() {
    const route = useRoute();
    const store = useStore();
    const isLoggedIn = computed(() => store.getters['auth/isLoggedIn']);
    const isSidebarShown = computed(() => {
      return route.path.includes('/login');
    });
    const handleAuthState = async () => {
      if (isLoggedIn.value) {
        try {
          const response = await api.get('keys/v1/keys');
          if (response.data.data) {
            const keyData = response.data.data[0];
            WalletService.setPrivateData(keyData);
            await store.dispatch('auth/setPrivateData', keyData);
          }
        } catch (error) {
          console.error(error);
        }
      }
    };

    watch(isLoggedIn, handleAuthState);
    return { isSidebarShown, isLoggedIn };
  },
};
</script>

<style lang="scss">
@import 'scss/variables';
@import 'scss/mixins';
@import 'scss/app';

.app {
  display: flex;
  align-items: stretch;
  overflow-x: hidden;
  flex: 1;
  min-height: 100vh;

  &__container {
    width: calc(100% - 24rem);
    padding: 4rem 2.5rem;
    margin-left: 24rem;

    &.active {
      margin-left: 0;
      width: 100%;
      padding: 0;
    }

    @include respond-to($tablet) {
      width: 100%;
      margin: 0;
    }
  }
}
</style>
